
import { defineComponent, PropType } from 'vue'
import { iColumn, iPhysicalModel } from '../../Metaweb'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import metawebPropertyListTabDescriptor from './MetawebPropertyListTabDescriptor.json'

export default defineComponent({
    name: 'metaweb-property-list-tab',
    components: { Accordion, AccordionTab },
    props: { selectedPhysicalModel: { type: Object as PropType<iColumn | iPhysicalModel | null> } },
    data() {
        return {
            metawebPropertyListTabDescriptor,
            physicalModel: null as iColumn | iPhysicalModel | null,
            categories: [] as any[]
        }
    },
    watch: {
        selectedPhysicalModel() {
            this.loadPhysicalModel()
        }
    },
    created() {
        this.loadPhysicalModel()
    },
    methods: {
        loadPhysicalModel() {
            this.physicalModel = this.selectedPhysicalModel as iColumn | iPhysicalModel

            this.loadCategories()
        },
        loadCategories() {
            this.categories = {} as any
            if (this.physicalModel) {
                for (let i = 0; i < this.physicalModel.properties.length; i++) {
                    const tempProperty = this.physicalModel?.properties[i]
                    const key = Object.keys(tempProperty)[0]
                    const newKey = key?.split('.')

                    if (!this.categories[newKey[0]]) {
                        this.categories[newKey[0]] = []
                    }
                    this.categories[newKey[0]].push(tempProperty[key])
                }
            }
        }
    }
})
